import { useMutation } from '@tanstack/react-query';

import { PersonalExpensesApi } from '../personalExpenses.api';

export const useSentPersonalExpensesByProduct = () => {
  return useMutation({
        mutationFn: PersonalExpensesApi.sentPersonalExpensesByProduct,
  })
};
